// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityPoliciesStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var { isEmpty } = require('lodash/fp');
  var extendObservable = require('mobx').extendObservable;
  var uiState = require('logic/Izenda.UiState');
  var m = require('mobx');
  var SecurityPolicies = require('logic/models/Izenda.SecurityPolicies');
  var fetcher = require('fetchers/Izenda.SystemSettingFetcher.js');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var localizer = require('share/localization/Izenda.Localizer');

  function SecurityPoliciesStore() {
    extendObservable(this, {
      model: new SecurityPolicies(),
      alertMessage: commonMessages.EMPTY_MESSAGE
    });
  }

  /**
   * init state store
   */
  SecurityPoliciesStore.prototype.init = m.action(function() {
    uiState.setCheckDirtyFunction(
      function() {
        return this.model.isDirty;
      }.bind(this)
    );
    this.alertMessage = commonMessages.EMPTY_MESSAGE;
  });

  /**
   * load Security Policies Detail
   * @returns {promise}
   */
  SecurityPoliciesStore.prototype.loadSecurityPoliciesDetail = m.action(function() {
    var model = this.model;
    var readSecuritPoliciesDetail = m.action(function(result) {
      model.readSecuritPolicies(result);
    });
    return fetcher.loadSecurityPolicies().then(readSecuritPoliciesDetail);
  });

  /**
   * save security policies
   * @return {promise}
   */
  SecurityPoliciesStore.prototype.save = m.action(function() {
    var model = this.model;
    var data = model.getDataForSave();

    var handleAfterSave = m.action(function(result) {
      if (isEmpty(result.messages)) {
        model.readSecuritPolicies(result);
        this.setAlertMessage('success', localizer.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED'));
        return true;
      }

      return result;
    });
    return fetcher
      .saveSecurityPolicies(data)
      .bind(this)
      .then(handleAfterSave);
  });

  /**
   * set Alert Message
   * @param {string} type
   * @param {string} message
   */
  SecurityPoliciesStore.prototype.setAlertMessage = function(type, message) {
    this.alertMessage = {
      type: type,
      message: message
    };
  };

  module.exports = SecurityPoliciesStore;
})();



// WEBPACK FOOTER //
// ./ui/logic/Izenda.SecurityPoliciesStore.js